import { render, staticRenderFns } from "./TentCheck.vue?vue&type=template&id=3747a286&lang=pug&"
import script from "./TentCheck.vue?vue&type=script&lang=js&"
export * from "./TentCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports